// Registry for Lab singletons
var Lab2Registry = /** @class */ (function () {
    function Lab2Registry() {
        this.projectManager = null;
    }
    Lab2Registry.getInstance = function () {
        if (Lab2Registry._instance === undefined) {
            Lab2Registry.create();
        }
        return Lab2Registry._instance;
    };
    Lab2Registry.hasEnabledProjects = function () {
        return (Lab2Registry._instance !== undefined &&
            Lab2Registry._instance.projectManager !== null);
    };
    Lab2Registry.create = function () {
        Lab2Registry._instance = new Lab2Registry();
    };
    Lab2Registry.prototype.setProjectManager = function (projectManager) {
        this.projectManager = projectManager;
    };
    Lab2Registry.prototype.getProjectManager = function () {
        return this.projectManager;
    };
    Lab2Registry.prototype.clearProjectManager = function () {
        this.projectManager = null;
    };
    return Lab2Registry;
}());
export default Lab2Registry;
